// import { AUTH_TOKEN } from "./constant";
    
// export const getToken = () => {
//     return localStorage.getItem(AUTH_TOKEN);
// };

// export const setToken = (token) => {
//     if (token) {
//     localStorage.setItem(AUTH_TOKEN, token);
//     }
// };

// export const removeToken = () => {
//     localStorage.removeItem(AUTH_TOKEN);
// };

// helpers.js

// helpers.js

export const setToken = (token, rememberMe = false) => {
  // Clear any existing tokens first to prevent conflicts
  localStorage.removeItem("authToken");
  sessionStorage.removeItem("authToken"); 
  
  if (rememberMe) {
    // 🔑 Long-term persistence
    localStorage.setItem("authToken", token);
  } else {
    // 🔑 Short-term persistence (clears when browser tab is closed)
    sessionStorage.setItem("authToken", token);
  }
};

export const getToken = () => {
  // Check localStorage first (for "Remember Me" token)
  const localToken = localStorage.getItem("authToken");
  if (localToken) {
    return localToken;
  }
  
  // Check sessionStorage next (for regular session token)
  const sessionToken = sessionStorage.getItem("authToken");
  if (sessionToken) {
    return sessionToken;
  }
  
  return null; // Return null or undefined if no token is found
};

export const removeToken = () => {
  // Ensure both storages are cleared on logout
  localStorage.removeItem("authToken");
  sessionStorage.removeItem("authToken");
};

// fetch() wrapper that sends the logged-in user's JWT and rejects on non-2xx
// responses, so callers' .catch() / try-catch actually run on 401/403.
export const authFetch = (url, options = {}) => {
  const token = getToken();
  const headers = { ...(options.headers || {}) };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return fetch(url, { ...options, headers }).then((res) => {
    if (!res.ok) {
      throw new Error(`Request failed: ${res.status} ${res.statusText}`);
    }
    return res;
  });
};
